export const BREADCRUMB_PORTAL_ID = 'breadcrumb-portal';
